// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.button-user img[data-v-7f9db54d] {\n  width: 35px;\n  height: 35px;\n  border-radius: 999px;\n  vertical-align: middle;\n}\n", ""]);
// Exports
module.exports = exports;
